import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GlobalHelper } from '../Common/global.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})

export class ResourceService {

  constructor(private globalHelper: GlobalHelper, private httpclient: HttpClient) { }

  // RESOURCE MASTER


  SaveResource(ObjModel, file): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", ObjModel);
    formData.append("ContentFile", file);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/SaveResource', formData);
  }

  GetAllResource(ObjModel): Observable<any> {
    let Parameter = 'ObjModel=' + ObjModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/GetAllResource?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  ResourceMarkActive(ResourceID,IsActive): Observable<any> {
    let Parameter = 'ResourceID=' + ResourceID+'&IsActive=' + IsActive;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/ResourceMarkActive?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

   // KNOWLEDGE BASE
  SaveKnowledgeBase(ObjModel, file): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", ObjModel);
    formData.append("Content", file);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/SaveKnowledgeBase', formData);
  }

  GetAllKnowledgeBase(ObjModel): Observable<any> {
    let Parameter = 'ObjModel=' + ObjModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/GetAllKnowledgeBase?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetKnowldegeResource(ObjModel): Observable<any> {
    let Parameter = 'ObjModel=' + ObjModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/GetKnowldegeResource?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

   // BLOG CATEGORY

   SaveBlogCategory(ObjModel): Observable<any> {
    let Parameter = 'ObjModel=' + ObjModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/SaveBlogCategory?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  GetAllBlogCategory(ObjModel): Observable<any> {
    let Parameter = 'ObjModel=' + ObjModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/GetAllBlogCategory?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

  // BlOG POST
  SaveBlogPost(ObjModel,content,file): Observable<any> {
    let formData = new FormData();
    formData.append("ObjModel", ObjModel);
    formData.append("Content", content);
    formData.append("ContentFile", file);
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/SaveBlogPost', formData);
  }

  GetAllBlogPost(ObjModel): Observable<any> {
    let Parameter = 'ObjModel=' + ObjModel;
    var reqHeader = new HttpHeaders({ 'Content-Type': 'application/x-www-urlencoded', 'No-Auth': 'True' });
    return this.httpclient.post<any>(this.globalHelper.ApiUrl + 'Resource/GetAllBlogPost?'
      + encodeURI(Parameter),
      { headers: reqHeader });
  }

 
}
